import React from 'react'
import cx from 'classnames'

import s from './Avatar.scss'

import noAvatarFemaleImage from './images/female.svg'
import noAvatarMaleImage from './images/male.svg'


type AvatarProps = {
  className?: string
  src?: string
  gender?: Gender
  circle?: boolean
}

const Avatar: React.FunctionComponent<AvatarProps> = (props) => {
  const { className, gender = 'female', src, circle } = props

  const imgSrc = src || (gender === 'female' ? noAvatarFemaleImage : noAvatarMaleImage)

  const avatarClassName = cx(s.avatar, {
    [s.noSrc]: !src,
    [s.circle]: circle,
  })

  return (
    <div className={className}>{/* ATTN this container required because .avatar looses square form if used as flex item (with stretch style) */}
      <div className={avatarClassName} style={{ backgroundImage: `url(${imgSrc})` }} />
    </div>
  )
}


export default React.memo(Avatar)
